export const isPresent = (t)=>{
    return t !== undefined && t !== null;
};
export const isDefined = (t)=>{
    return t !== undefined;
};
export const isNotNull = (t)=>{
    return t !== null;
};
export const isHTMLElement = (t)=>{
    return t instanceof HTMLElement;
};
